"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TheDeathDoctrineAbilityHandler = exports.TheDeathDoctrineActorAbilityFactory = exports.TheDeathDoctrineAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const EventType_1 = require("../../core/events/EventType");
const Schedule_1 = require("../../core/Schedule");
const __1 = require("../..");
const Duration_1 = require("../../core/Duration");
class TheDeathDoctrineAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.TheDeathDoctrine;
        this.__typeName = "TheDeathDoctrine";
    }
}
exports.TheDeathDoctrineAbilityArgs = TheDeathDoctrineAbilityArgs;
let TheDeathDoctrineActorAbilityFactory = class TheDeathDoctrineActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("TheDeathDoctrine", "Self", 0);
    }
};
TheDeathDoctrineActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("TheDeathDoctrine")
], TheDeathDoctrineActorAbilityFactory);
exports.TheDeathDoctrineActorAbilityFactory = TheDeathDoctrineActorAbilityFactory;
let TheDeathDoctrineAbilityHandler = class TheDeathDoctrineAbilityHandler {
    init(sequence, container, actorId) {
        const damagedEventHandlerId = container.registerEventHandler(actorId, EventType_1.EventType.Damaged, Schedule_1.Schedule.Unlimited, new __1.ApplyEffectToDamagerEventHandlerArgs(actorId, Duration_1.Duration.Turns(5), new __1.VulnerabilityEffectArgs(1)));
        container.registerEventHandler(actorId, EventType_1.EventType.Killed, Schedule_1.Schedule.Once(), new __1.CancelEventHandlersEventHandlerArgs([damagedEventHandlerId]));
    }
    activate(sequence, container, ability) {
        throw new Error("PASSIVE_ONLY");
    }
};
TheDeathDoctrineAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.TheDeathDoctrine)
], TheDeathDoctrineAbilityHandler);
exports.TheDeathDoctrineAbilityHandler = TheDeathDoctrineAbilityHandler;
